import {
  OES_PLUS_PRODUCT_TYPE,
  OEC_PRODUCT_TYPE,
  OEC_TURBO_PRODUCT_TYPE,
  OEA_PRODUCT_TYPE,
  OEA_LITE_PRODUCT_TYPE,
} from '@/pages/income/config';

// 设备状态
// 待完成
export const ACT_UNFINISHED_STATUS = 0;
// 待领取
export const ACT_NOT_RECEIVED_STATUS = 1;
// 超时未完成
export const ACT_TIMEOUT_UNFINISHED_STATUS = 2;
// 超时未领取
export const ACT_TIMEOUT_NOT_RECEIVED_STATUS = 3;
// 已领取
export const ACT_RECEIVED_STATUS = 4;
// 已结束
export const ACT_ENDED_STATUS = 5;

// 活动最大奖励月数
export const ACT_MAX_REWARD_MONTH_NUM = 12;

export const ACT_DEVICE_CONFIG = {
  [OEA_LITE_PRODUCT_TYPE]: {
    prefix: 'oea',
    reward: '迅雷白金会员',
    condition: [
      '每日在线≥20个小时',
      '每日晚高峰18点-24点的平均跑量≥6M',
      '使用网络为移动、联通、电信三大运营商之一',
    ],
  },
  [OEA_PRODUCT_TYPE]: {
    prefix: 'oea',
    reward: '迅雷白金会员',
    condition: [
      '每日在线≥20个小时',
      '每日晚高峰18点-24点的平均跑量≥6M',
      '使用网络为移动、联通、电信三大运营商之一',
    ],
  },
  [OEC_PRODUCT_TYPE]: {
    prefix: 'oec',
    reward: '迅雷超级会员',
    condition: [
      '每日在线≥20个小时',
      '每日晚高峰18点-24点的平均跑量≥20M',
      '使用网络为移动、联通、电信三大运营商之一',
    ],
  },
  [OEC_TURBO_PRODUCT_TYPE]: {
    prefix: 'oecTurbo',
    reward: '迅雷超级会员',
    condition: [
      '每日在线≥20个小时',
      '每日晚高峰18点-24点的平均跑量≥20M',
      '使用网络为移动、联通、电信三大运营商之一',
    ],
  },
  [OES_PLUS_PRODUCT_TYPE]: {
    prefix: 'oesPlus',
    reward: '迅雷超级会员',
    condition: [
      '每日在线≥20个小时',
      '每日晚高峰18点-24点的平均跑量≥30M',
      '使用网络为移动、联通、电信三大运营商之一',
    ],
  },
};

export const TIME_FORMAT = 'YYYY-MM';
export const DEFAULT_TEXT = '--';

// 每天达标状态
// 未达标
export const DAY_NOT_MEET_STATUS = 0;
// 达标
export const DAY_MEET_STATUS = 1;
// 已退出
export const DAY_QUIT_STATUS = 2;

export const MEET_STATUS_OPTIONS = [
  {
    value: DAY_MEET_STATUS,
    label: '已达标',
  },
  {
    value: DAY_NOT_MEET_STATUS,
    label: '未达标',
  },
];

export const FAIL_REASON_MAP = {
  '-1': '退出活动',
  '1': '在线时长未达标，或磁盘存在异常，请保证设备稳定在线',
  '2': '当日晚高峰贡献带宽未满足要求',
  '3': '运营商不符合条件',
};

export const DEFAULT_CALENDAR_ITEM = {
  day: '',
  d: '',
  s: -1,
  fr: '',
};

export const MODAL_CONTENT = {
  onlineDays: {
    title: '在线达标要求',
    content: `需同时满足以下要求：\n① 每日在线≥20个小时；\n② 每日晚高峰18点-24点的平均贡献带宽：OEA≥6M；OEC系列≥20M；OES系列≥30M；\n③ 使用网络为移动、联通、电信三大运营商之一。`,
  },
  'timeoutStatus-2': {
    title: '温馨提示',
    content: '您未在规定时间内完成累计7天在线，依据活动规则，视为放弃领取迅雷会员资格。',
  },
  'timeoutStatus-3': {
    title: '温馨提示',
    content:
      '您未在规定时间内填写手机号/迅雷账号领取迅雷会员资格，依据活动规则，已视为自动放弃迅雷会员年卡资格。',
  },
};

export const RECOMMEND_DEVICE_LIST = [
  {
    deviceType: OEA_PRODUCT_TYPE,
    reward: `送价值180元${ACT_DEVICE_CONFIG[OEA_PRODUCT_TYPE].reward}年卡`,
    income: '120元/月',
    prefix: ACT_DEVICE_CONFIG[OEA_PRODUCT_TYPE].prefix,
    link: `youzan:https%3A%2F%2Ftuicashier.youzan.com%2Fpay%2Fwscgoods_order%3Falias%3D1y34npvh1tkdojz`,
  },
  {
    deviceType: OEC_TURBO_PRODUCT_TYPE,
    reward: `送价值360元${ACT_DEVICE_CONFIG[OEC_TURBO_PRODUCT_TYPE].reward}年卡`,
    income: '600元/月',
    prefix: ACT_DEVICE_CONFIG[OEC_TURBO_PRODUCT_TYPE].prefix,
    link: `youzan:https%3A%2F%2Fshop90316740.m.youzan.com%2Fwscgoods%2Fdetail%2F2x5ozty4ykpos8e`,
  },
  {
    deviceType: OEC_PRODUCT_TYPE,
    reward: `送价值360元${ACT_DEVICE_CONFIG[OEC_PRODUCT_TYPE].reward}年卡`,
    income: '480元/月',
    prefix: ACT_DEVICE_CONFIG[OEC_PRODUCT_TYPE].prefix,
    link: `youzan:https%3A%2F%2Fshop90316740.m.youzan.com%2Fwscgoods%2Fdetail%2F35ya5uqxqxzpomt`,
  },
  {
    deviceType: OES_PLUS_PRODUCT_TYPE,
    reward: `送价值360元${ACT_DEVICE_CONFIG[OES_PLUS_PRODUCT_TYPE].reward}年卡`,
    prefix: ACT_DEVICE_CONFIG[OES_PLUS_PRODUCT_TYPE].prefix,
    income: '1200元/月',
    link: `youzan:https%3A%2F%2Ftuicashier.youzan.com%2Fpay%2Fwscgoods_order%3Falias%3D2g30vdxjo9qe443`,
  },
];

export const DEFAULT_ANNIVERSARY_DEVICE_INFO = {
  sn: '--',
  dt: '',
  st: ACT_UNFINISHED_STATUS,
  rmn: '--',
  td: '--',
  cdt: '--',
};

export const DEFAULT_HARDWARE_RECALL_INFO = {
  uid: 0,
  cb_num: 0,
  dev_num: 0
}
